import { render, staticRenderFns } from "./pointer.vue?vue&type=template&id=471b4bf8&scoped=true&"
import script from "./pointer.vue?vue&type=script&lang=js&"
export * from "./pointer.vue?vue&type=script&lang=js&"
import style0 from "./pointer.vue?vue&type=style&index=0&id=471b4bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471b4bf8",
  null
  
)

export default component.exports